import '../../Styles/DraggableWorkerGrid.css'
import { useDrop } from 'react-dnd';

function Slot({ index, worker, onDropWorker, isAdmin, DraggableWorker, onDelete, onEdit }) {
    const [, ref] = useDrop({
        accept: "worker", 
        drop: (item) => {
          onDropWorker(index, item.id);
        },
      });
    return (
      <div className={`slot slot-${index}`} ref={ref}>
        {worker ? (
          <DraggableWorker
            worker={worker}
            moveWorker={onDropWorker}
            isAdmin={isAdmin}
            onDelete={onDelete}
            handleEditClick={onEdit}
          />
        ) : (
            isAdmin ? "Empty Slot" : ""
        )}
      </div>
    );
  }

export default Slot;